const getApiUrl = () => {
  console.log(`NODE_ENV`, process.env.NODE_ENV);
  if (process.env.NODE_ENV === 'development') {
    return `http://localhost:3001`;
  }
  return `https://api.deminut.com.uy`;
}

export const API_URL = getApiUrl();
